import { ReactElement } from "react";

export function TableHead(props: {text: string, icon?: ReactElement, action?: () => void, type?: number}) {
    const getHeadClass = () => {
        switch(props.type) {
            case 1:
                return "Services__TableHeaderItem";
            case 2:
                return "Services__TableHeaderItem1";
            case 3:
                return "Services__TableHeaderItem2";
            case 4:
                return "Services__TableHeaderItem3";
            case 6:
                return "Services__TableHeaderItem4";
            case 5:
                return "Services__TableHeaderItem5";
            case 7:
                return "th-item";
            case 8:
                return "th-org";
            default:
                return "Card__AppoinmetHeaderTableText";
        }
    }
    const action = () => {
        if(props.action){
            props.action();
        }
    }
    return (
        <p onClick={action} className={getHeadClass()}>
            {props.text}
            {props.icon?? null}
        </p>
    )
}

export function TableHeaders(props: {children: ReactElement, type?: number}) {
    const getTableHeadClass = () => {
        switch(props.type) {
            case 1:
                return "Services__TableHeader";
            case 2:
                return "Services__TableHeaderSmall";
            case 3:
                return "t-org__header";
            default:
                return "Card__AppointmentHeaderTable";
        }
    }
    return (
        <div className={getTableHeadClass()}>
            {props.children}
        </div>
    )
}

export default function Table(props: {children: ReactElement, type?: number }) {
    const getTableClass = () => {
        switch(props.type) {
            case 1:
                return "Services__Table";
            case 2:
                return "t-org";
            default:
                return "Card__AppointmentTable";
        }
    }
    return (
        <div className={getTableClass()}>
            {props.children}
        </div>
    )
}